














































































import { Vue, Component, Watch } from "vue-property-decorator";
import RequestHandler from "@/assets/ts/requestHandler.ts";
import hubAppDefaults from "@/assets/constants/defaultSettings.json";
const requestHandler = new RequestHandler();

@Component
export default class Settings extends Vue {
  private hubAppConfig: any = Object.assign(
    {},
    hubAppDefaults,
    this.$store.getters["hubAppConfig"]
  );
  private printSettings: any = [
    { name: "Default Printer", printer: "", bin: "Tray 1" }
  ];
  private networkPrinters: Array<any> = [];
  private trays = ["Tray 1", "Tray 2", "Tray 3", "Tray 4", "Tray 5", "Tray 6"];
  loading = false;
  initialLoad = true;
  hubAppLink = "";

  async beforeCreate() {
    this.hubAppLink =
      (await requestHandler.getConfig()).config.hubDownloadBaseLocation +
      "StarInstaller.exe";
    try {
      await requestHandler.setHubConfigs();
      if (this.$store.getters["hubAppConfig"].printSettings.length > 0) {
        this.printSettings = [
          ...this.$store.getters["hubAppConfig"].printSettings
        ];
      }
      this.networkPrinters = await requestHandler.getPrinters();
    } catch (e) {
      console.error(e);
      this.$root.$emit("snackbar-message", {
        text: "Hub app not running.",
        color: "red"
      });
    } finally {
      this.initialLoad = false;
    }
  }

  async saveSettings() {
    const payload: any = {};
    Object.keys(this.hubAppConfig).forEach(key => {
      if (key in hubAppDefaults) {
        payload[key] = this.hubAppConfig[key];
      }
    });

    payload.printSettings = this.printSettings;

    payload.silentUpdate = true;
    payload.updateSchedule =
      (await requestHandler.getConfig()).config.hubAppUpdateSchedule ??
      "0 3 * * *";

    try {
      await requestHandler.storeHubAppSettings(payload);
      this.loading = true;
      this.$root.$emit("snackbar-message", {
        text: "Settings saved.",
        color: "green"
      });
    } catch (e) {
      console.error(e);
      this.$root.$emit("snackbar-message", {
        text: "Unable to save settings.",
        color: "red"
      });
      return;
    } finally {
      this.loading = false;
    }
  }
}
